
import Msg from 'vux/src/components/msg/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
props: ['desc'],
components: {
Msg,
XButton
},
methods: {
changeIcon() {

}
},
computed:{
description(){
return this.$props.desc? this.$props.desc : '您暂时无法进行此操作，原因可能是你网络问题，或是微信服务登录失败。请稍后重试。'
}
},
data() {
return {

icon: 'warn',
buttons: [
/*                    {
type: 'default',
text: '关闭',
onClick: this.changeIcon
}*/
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/Error.vue